/**
 * Built-in effect `grayscale` (W2-01b; P§5.2): mixes the picture toward its luminance grey by `factor` (0 =
 * unchanged, 1 = fully grey; Rec. 601 luma). Reimplemented from the behaviour (badged approximate).
 */

import { m } from './builtinFx.messages';
import { defineBuiltin, LUMA } from './shared';

export const grayscale = defineBuiltin({
  name: 'grayscale',
  label: { key: m.grayscale },
  description: { key: m.grayscaleDesc },
  inputs: [],
  uniforms: [
    { name: 'factor', type: 'float', default: 1, hint: '0..1', min: 0, max: 1, label: { key: m.grayscaleFactor } },
  ],
  helpers: [LUMA],
  main: `
void main() {
  vec4 c = texture2D(screenTexture, uv);
  gl_FragColor = vec4(mix(c.rgb, vec3(luma(c.rgb)), factor), c.a);
}`,
});
